function u(r) {
  return r < 0 ? 0 : r > 1 ? 1 : r;
}
function a(r, t, n) {
  return Math.min(n, Math.max(t, r));
}
export {
  a as clamp,
  u as clamp01
};
